import { atom } from 'jotai'
import { atomWithQuery } from 'jotai/query'
import { AxiosResponse } from 'axios'
import { axiosWithImitator } from '../withAuth'
import {
    mapMembers,
    IMemberData,
    IUpdateMemberData,
    Member,
    ICancelWorkplace,
    ITransferMemberToOtherWorkplace,
    IRemoveMemberFromOwnList,
} from '../../models/Member'
import { IFilterData, initFilter } from '../../utils/filterhelper'
import { IFilter } from '../../models/Filter'
import { mapWorkplaces, Workplace } from '../../models/Workplace'

export type TypeResponseGetMembers = {
    Medlemmer: IMemberData[]
}
export type TypeResponse = TypeResponseGetMembers & IFilterData
const idAtom = atom(1)

const membersAtom = atomWithQuery((get) => ({
    queryKey: ['members', get(idAtom)],
    queryFn: async () => {
        // const url = `/medlem/hentegnemedlemmer`
        const url = '/medlem/hentegnemedlemmerprarbejdsstedprtrhverv'
        const response = await axiosWithImitator.get(url)

        const { data } = response
        return {
            members: mapMembers(data.Medlemmer),
            filter: initFilter(data),
        }
    },
}))

const getOwnMembers = async (): Promise<{
    members: Member[]
    filter: IFilter
}> => {
    const response = await axiosWithImitator.get(`/medlem/hentegnemedlemmer`)

    const { data } = response
    return {
        members: mapMembers(data.Medlemmer),
        filter: initFilter(data),
    }
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const searchMembers = async (queryString: string) => {
    let error
    try {
        const response = await axiosWithImitator.get(
            `/medlem/soegallemedlemmer?${queryString}`
        )

        return response
    } catch (err) {
        error = err
        return error
    }
}

const getOwnMember = async (id: string): Promise<AxiosResponse> => {
    const response = await axiosWithImitator.get(
        `/medlem/hentegetmedlem?request.medlemsident=${id}`
    )

    return response
}

const getMemberAfterSearch = async (id: number): Promise<AxiosResponse> => {
    const response = await axiosWithImitator.get(
        `/medlem/hentsoegmedlem?request.medlemsident=${id}`
    )

    return response
}

const updateOwnMember = async (
    values: IUpdateMemberData
): Promise<AxiosResponse> => {
    const response = await axiosWithImitator.post(
        `/opdatering/opdatermedlem`,
        values
    )
    return response
}

// opdatering/opdaterogtilfoejeksisterendemedlem
const addMemberToOwnList = async (
    values: IUpdateMemberData
): Promise<AxiosResponse> => {
    const response = await axiosWithImitator.post(
        `/opdatering/opdaterogtilfoejeksisterendemedlem`,
        values
    )
    return response
}

const transferMemberToOtherWorkplace = async (
    values: ITransferMemberToOtherWorkplace
): Promise<AxiosResponse> => {
    const response = await axiosWithImitator.post(
        `/opdatering/SkiftMedlemArbejdssted`,
        values
    )
    return response
}

// opdatering/tilfoejmedlemarbejdssted
const addMemberToWorkplace = async (
    values: IUpdateMemberData
): Promise<AxiosResponse> => {
    const response = await axiosWithImitator.post(
        `/opdatering/tilfoejmedlemarbejdssted`,
        values
    )
    return response
}

const removeMemberFromOwnList = async (
    values: IRemoveMemberFromOwnList
): Promise<AxiosResponse> => {
    const response = await axiosWithImitator.post(
        `/opdatering/MedlemSkiftetStillingTRIkkeDaekker`,
        values
    )
    return response
}

const cancelMemberFromWorkplace = async (
    values: ICancelWorkplace
): Promise<AxiosResponse> => {
    const response = await axiosWithImitator.post(
        `/opdatering/medlemophoert`,
        values
    )
    return response
}

// /medlem/hentegnemedlemmerprarbejdsstedprtrhverv
const getMemberWorkPlaces = async (): Promise<{
    workplaces: Workplace[]
}> => {
    const response = await axiosWithImitator.get(
        '/medlem/hentegnemedlemmerprarbejdsstedprtrhverv'
    )

    return {
        workplaces: mapWorkplaces(response.data.ArbejdsstedTRHvervMedlemLister),
    }
}

export {
    membersAtom,
    searchMembers,
    getMemberAfterSearch,
    getOwnMember,
    getOwnMembers,
    updateOwnMember,
    addMemberToOwnList,
    addMemberToWorkplace,
    cancelMemberFromWorkplace,
    getMemberWorkPlaces,
    transferMemberToOtherWorkplace,
    removeMemberFromOwnList,
}
